export default __webpack_public_path__ + "static/media/transport-ship.8a46ed6e.svg";